import { Directive, ElementRef, Inject, InjectionToken, OnInit, Optional, Renderer2 } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";
import { MILLISECONDS_IN_MINUTE } from "@dtm-frontend/shared/utils";

export const CLICK_ONLY_MAT_TOOLTIP_CLASS = "click-only-mat-tooltip";
export const CLICK_ONLY_MAT_TOOLTIP_SHOW_DELAY = new InjectionToken<number>("CLICK_ONLY_MAT_TOOLTIP_SHOW_DELAY");

const DEFAULT_CLICK_ONLY_MAT_TOOLTIP_SHOW_DELAY = MILLISECONDS_IN_MINUTE;

@Directive({
    selector: "[dtmUiClickOnlyMatTooltip][matTooltip]",
    standalone: true,
    host: {
        "(click)": "onElementClick($event)",
    },
})
export class ClickOnlyMatTooltipDirective implements OnInit {
    private readonly showDelay: number;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private matTooltip: MatTooltip,
        @Optional() @Inject(CLICK_ONLY_MAT_TOOLTIP_SHOW_DELAY) showDelay: number | null
    ) {
        this.showDelay = showDelay ?? DEFAULT_CLICK_ONLY_MAT_TOOLTIP_SHOW_DELAY;
    }

    public ngOnInit(): void {
        this.renderer.addClass(this.elementRef.nativeElement, CLICK_ONLY_MAT_TOOLTIP_CLASS);

        this.matTooltip.showDelay = this.showDelay;
        this.matTooltip.hideDelay = 0;
    }

    public onElementClick(event: MouseEvent): void {
        event.stopPropagation();

        if (!this.matTooltip.disabled) {
            this.matTooltip.showDelay = 0;
            this.matTooltip.show();
            this.matTooltip.showDelay = this.showDelay;
        }
    }
}
